import component from './SelfPost';
import handles from './handles';

export default {
  component,
  handles,
};



// WEBPACK FOOTER //
// ./src/components/SelfPost/index.js